import { render } from "./DocumentReader.vue?vue&type=template&id=f9826f92&scoped=true"
import script from "./DocumentReader.vue?vue&type=script&lang=js"
export * from "./DocumentReader.vue?vue&type=script&lang=js"

import "./DocumentReader.vue?vue&type=style&index=0&id=f9826f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9826f92"]])

export default __exports__